import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-failure',
  templateUrl: './item-failure.component.html',
  styleUrls: ['./item-failure.component.scss']
})
export class ItemFailureComponent implements OnInit {

  isMobile:boolean = false;

  constructor(private breakPointObserver: BreakpointObserver ) {

  }

  ngOnInit(): void {
    this.breakPoint();
  }

  breakPoint(){
    this.breakPointObserver.observe([Breakpoints.XSmall]).subscribe( result => {
      if(result.matches){
        this.isMobile = true;
      }else{ 
        this.isMobile = false;
      }
    });
  }

}
